import * as React from 'react';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import {
  IUIUrval,
  TEDInputUrvalType,
  TEDUrvalVisibility,
} from '../../../../../../../Types/UrvalTypes';
import SaveNewUrval from '../SaveNewUrval';
import { KodplanConsumer } from '../../../../../../KodplanManager/Context/KodplanContext';

interface IProps {
  title: string;
  saveUrval: (urval: IUIUrval, urvalInput: TEDInputUrvalType) => Promise<void>;
  urval: IUIUrval;
  collectionName: string;
  userId?: string;
  rutinId: number;
  open: boolean;
  onClose: () => void;
  usageCode?: string;
  availableVisibilityOptions: TEDUrvalVisibility[];
}

interface IState {
  error: boolean;
}

class SaveNewUrvalDialog extends React.Component<IProps, IState> {
  okClick: (() => void) | undefined = undefined;
  constructor(props: IProps) {
    super(props);
    this.state = {
      error: true,
    };
  }

  setOKClick = (okClick: () => void) => {
    this.okClick = okClick;
  };

  handleOKClick = () => {
    if (this.okClick) {
      this.okClick();
    }
  };

  setError = (error: boolean) => {
    this.setState({
      error: error,
    });
  };

  render() {
    return (
      <Dialog
        data-test={`dialog:${this.props.title}`}
        open={this.props.open}
        title={this.props.title}
        onClose={this.props.onClose}
        footerActions={[
          {
            onClick: this.props.onClose,
            label: 'Avbryt',
          },
          {
            onClick: this.handleOKClick,
            label: 'Spara',
            buttonProps: {
              disabled: this.props.userId == null || this.state.error,
            },
          },
        ]}
      >
        <KodplanConsumer>
          {({ activeKodplan }) => (
            <SaveNewUrval
              setOKClick={this.setOKClick}
              saveNewUrval={this.props.saveUrval}
              urval={this.props.urval}
              collectionName={this.props.collectionName}
              userId={this.props.userId}
              rutinId={this.props.rutinId}
              onSuccess={this.props.onClose}
              kodplanID={activeKodplan ? activeKodplan.id : undefined}
              setError={this.setError}
              usageCode={this.props.usageCode}
              availableVisibilityOptions={this.props.availableVisibilityOptions}
            />
          )}
        </KodplanConsumer>
      </Dialog>
    );
  }
}

export default SaveNewUrvalDialog;
